<template>
  <div id="app">
    <!-- <Header /> -->

    <div>
      <!-- component matched by the route renders below -->
      <div class="p-grid">
        <div id="AppMenuCol" class="p-col-12 p-sm-4 p-md-3" v-if="showAppMenu">
          <AppMenu style="margin: 0 auto;"></AppMenu>
        </div>
        <RDChatBot />
        <div
          :class="{
            'p-col p-sm-8 p-md-9': showAppMenu,
            'p-col-12': !showAppMenu,
          }"
          style="padding: 0px"
        >
          <Toast position="bottom-right" />
          <div id="content" v-bind:style="contentStyle">
            <router-view />
            <ConfirmBanner v-if="currentUser && !currentUser.confirmed" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppMenu from "@/components/AppMenu";
import RDChatBot from "@/components/RDChatBot";
import ConfirmBanner from "@/components/ConfirmBanner.vue";

export default {
  metaInfo() {
    return { title: "Diamond Scheduler" };
  },
  components: {
    ConfirmBanner,
    AppMenu,
    RDChatBot,
  },
  data: function() {
    return {
      sidebar: true,
    };
  },
  computed: {
    busyAction() {
      console.log("Compute busyAction: " + window.busyAction);
      return window.busyAction;
    },
    contentStyle() {
      const whiteBg =
        this.$route.name &&
        (this.$route.name.includes("SportsEngine") ||
          this.$route.name.includes("Wizard") ||
          this.$route.name.includes("Embed") ||
          this.$route.name.includes("Schedule") ||
          this.$route.name.includes("List") ||
          this.$route.name.includes("Bulk") ||
          this.$route.name.includes("Tournament") ||
          this.$route.name.includes("LeagueForm")) &&
        !this.$route.name.includes("PublicSchedules") &&
        !this.$route.name.includes("PublicScores");
      if (whiteBg) {
        return { background: "white" };
      }
      return {};
    },
    showAppMenu() {
      const hiddenRoutes = [
        "Embed",
        "Bulk",
        "Wizard",
        "Activity",
        "Admin",
        "Timeslots",
        "Callback",
        "Calendar",
        "Setup",
        "Master",
        "PublicHome",
        "PublicTeam",
        "PublicStandings",
        "PublicSchedules",
        "PublicScores",
        "SignupWizard",
        "Billing",
      ];

      return (
        this.isAuthenticated &&
        this.$store.getters.leagueInformation &&
        this.$store.getters.leagueInformation.length > 0 &&
        !hiddenRoutes.includes(this.$route.name)
      );
    },
  },
  methods: {
    goBack() {
      if (window.lastRoute.includes("wizard")) {
        console.log("Block wizard back");
        this.goRouter("/");
        return;
      }
      this.$router.go(-1);
    },
  },
  created() {
    this.$store.dispatch("getLeagueInformation");
  },
};
</script>

<style scoped lang="scss">
div {
  text-align: center;
}
#content {
  padding: 4rem 2rem 2rem 2rem;
}
</style>